<h1 mat-dialog-title>Reproducir audio</h1>
<div mat-dialog-content>
  <p>{{ strNombredoc }}</p>
  <div class="d-flex justify-content-center">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <!--[ngClass]="(varEstPermiteImportar)?'col-1':'col-2'" hidden="(NoClick)"-->
          <div *ngIf="(NoClick)">
            <a class="col-1" (click)='ReproAudio()'>
              <p>
                <img src="assets/icPlay.png" />
              </p>
              <span>
                Click para reproducir
              </span>
            </a>
          </div>
          <div *ngIf="!(NoClick)">
            <span>
              <p> {{this.strMensaje}}</p>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
<div mat-dialog-actions class="d-flex justify-content-center">
  <button mat-button (click)="Cerrar()">Cerrar</button>
</div>
